/** Réglages des fonds du thème Donjon et aventure (voir ../reglages.js pour la description des types). */
export const REGLAGES = {
    vitesse: {
        type: "nombre", libelle: "Vitesse de l'animation", min: 0.5, max: 2, pas: 0.1, defaut: 1, unite: "×",
        aide: "×1 est la vitesse d'origine.",
    },
    nombre: {
        type: "nombre", libelle: "Nombre d'éléments", min: 3, max: 20, pas: 1, defaut: 8,
        aide: "Torches, braises ou objets selon le fond (20 au plus, pour garder l'écran léger).",
    },
    ambiance: {
        type: "choix", libelle: "Ambiance", defaut: "pierre",
        options: [{valeur: "pierre", libelle: "Pierre et feu"}, {valeur: "glace", libelle: "Glace et magie bleue"}, {valeur: "lave", libelle: "Lave et braises"}],
    },
};

/** Couleurs de chaque ambiance : murs (clair, sombre, joints), flamme (cœur, bord), objets. */
export const AMBIANCES = {
    pierre: {mur: "#4a4458", mur2: "#2c2836", joint: "#171420", coeur: "#fff3b0", flamme: "#ff9d2e", objets: ["#ffd24a", "#c9c9d6", "#b86a3b", "#8ad1ff"]},
    glace: {mur: "#3c5670", mur2: "#1f3248", joint: "#0d1a29", coeur: "#e6fbff", flamme: "#4fd0ff", objets: ["#e6fbff", "#8ad1ff", "#b9a6ff", "#ffd24a"]},
    lave: {mur: "#4a2a26", mur2: "#2a1512", joint: "#120807", coeur: "#fff0a0", flamme: "#ff5a1f", objets: ["#ffb13b", "#ff5a1f", "#d9d9d9", "#ffd24a"]},
};

/** Dessins en pixels des objets (un caractère = un pixel) : coffre, épée, bouclier, potion, clé. Originaux et génériques. */
export const OBJETS = {
    coffre: [
        "..########..",
        ".##########.",
        "############",
        "############",
        "#....##....#",
        "############",
        "##########..",
        "############",
    ],
    epee: [
        ".......##",
        "......###",
        ".....###.",
        "....###..",
        "#..###...",
        ".####....",
        "..##.....",
        ".#.##....",
        "#...#....",
    ],
    bouclier: [
        "##########",
        "#........#",
        "#...##...#",
        "#..####..#",
        "#...##...#",
        ".#......#.",
        "..#....#..",
        "...####...",
    ],
    potion: [
        "...####...",
        "....##....",
        "...####...",
        "..######..",
        ".########.",
        ".########.",
        ".########.",
        "..######..",
    ],
    cle: [
        "..###.....",
        ".#...#....",
        ".#...#....",
        "..###.....",
        "...#......",
        "...##.....",
        "...#......",
        "...###....",
    ],
};

export const NOMS_OBJETS = ["coffre", "epee", "bouclier", "potion", "cle"];
